import { IAppReducer } from 'models';
import { Coupon } from 'pages/Settings/pages/Add-subscription/types/Add-subscription.types';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getCouponByCouponNameAndCompanyId } from 'shared/services/form-coupon-price';

interface UseFormCuponPriceReturn {
  couponError: string | null;
  appliedCoupon: Coupon | null;
  couponCode: string;
  loadingCoupon: boolean;
  resetCoupon: () => void;
  handleCouponCode: (coupon: string) => void;
  handleApplyCoupon: () => void;
}

export const useFormCuponPrice = (): UseFormCuponPriceReturn => {
  const { authReducer: user } = useSelector((state: IAppReducer) => state);
  const [couponError, setCouponError] = useState<string | null>(null);
  const [appliedCoupon, setAppliedCoupon] = useState<Coupon | null>(null);
  const [couponCode, setCouponCode] = useState<string>('');
  const [loadingCoupon, setLoadingCoupon] = useState<boolean>(false);

  const resetCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode('');
    setCouponError(null);
  };

  const handleCouponCode = (coupon: string) => {
    setCouponCode(coupon);
  };

  const handleApplyCoupon = async () => {
    setLoadingCoupon(true);
    try {
      const coupon = await getCouponByCouponNameAndCompanyId({
        couponCode,
        companyId: user.companyId,
      });
      if (!coupon) {
        setCouponError('Cupón invalido');
        setAppliedCoupon(null);
        return;
      }
      setAppliedCoupon(coupon);
      setCouponError(null);
    } catch (error) {
      setCouponError('Error aplicando el cupón');
    } finally {
      setLoadingCoupon(false);
    }
  };

  return {
    couponError,
    appliedCoupon,
    couponCode,
    loadingCoupon,
    resetCoupon,
    handleCouponCode,
    handleApplyCoupon,
  };
};
